module.exports = __webpack_public_path__ + "img/timeline_miscevent-3.1d952be3.jpg";